/* Mobile Selleasy FBT formatting. No changes to selections, prices or cart handlers. */
(function () {
  'use strict';
  var media = window.matchMedia('(max-width: 768px)');
  var suffixes = [
    '1755068780ab1e9756', '175550854720170e82',
    '17576403893efa8fdd', '17591312546a8cc139',
    '175550920920340a1a', '175557585708e53066'
  ];
  var selector = suffixes.map(function (id) { return '[id$="__' + id + '"]'; }).join(',');
  var queued = false;

  function text(node) { return (node.textContent || '').replace(/\s+/g, ' ').trim(); }

  function markTitles(root) {
    var candidates = Array.from(root.querySelectorAll(
      'a[href*="/products/"], [class*="product-title" i], [class*="product-name" i], ' +
      '[class*="product_title" i], [class*="product_name" i], [class*="productTitle"], [class*="productName"]'
    ));
    // Use the lowest text-only element. Never crop a card containing image/price/controls.
    candidates.filter(function (node) {
      var value = text(node);
      return value.length >= 23 && value.length < 240 && !/[\$€£¥]\s?\d/.test(value) &&
        !/bundle|save|discount|total|cart/i.test(value) &&
        !node.querySelector('img,button,input,select');
    }).forEach(function (node) {
      var textOnlyChildren = Array.from(node.children).filter(function (child) {
        return text(child) === text(node) && !child.querySelector('img,input,button,select');
      });
      var target = textOnlyChildren.length === 1 ? textOnlyChildren[0] : node;
      target.classList.add('rc-selleasy-title-mobile');
      if (target.parentElement) target.parentElement.classList.add('rc-selleasy-title-parent-mobile');
    });
  }

  function markTotal(root) {
    var nodes = Array.from(root.querySelectorAll('span,div,p,strong,b'));
    var label = nodes.find(function (el) {
      return !el.children.length && /^total:?$/i.test(text(el));
    });
    if (!label) return;
    for (var ancestor = label.parentElement, depth = 0; ancestor && ancestor !== root && depth < 5; ancestor = ancestor.parentElement, depth++) {
      var content = text(ancestor);
      if (content.length > 350) break;
      if (/[\$€£¥]\s?[\d,.]+/.test(content) && ancestor.children.length > 1) {
        ancestor.classList.add('rc-selleasy-total-mobile');
        label.classList.add('rc-selleasy-total-label-mobile');
        break;
      }
    }
  }

  function apply() {
    if (!media.matches) return;
    document.querySelectorAll(selector).forEach(function (section) {
      // Restrict changes to the live FBT widget. Other Selleasy app blocks are untouched.
      var content = text(section);
      if (!/add bundle to cart/i.test(content) || !/total/i.test(content)) return;
      section.classList.add('rc-selleasy-mobile-fbt');
      markTitles(section);
      markTotal(section);
    });
  }

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; apply(); });
  }
  function init() {
    schedule();
    new MutationObserver(function (records) {
      // Ignore class changes from this script; apply only after app markup changes.
      if (records.some(function (r) { return r.addedNodes.length || r.removedNodes.length; })) schedule();
    }).observe(document.body, { childList: true, subtree: true });
    if (media.addEventListener) media.addEventListener('change', schedule);
    else media.addListener(schedule);
    document.addEventListener('shopify:section:load', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
